/**
 * @generated SignedSource<<5c70ef7feff7070631e1fc91528515d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentSystemTaskKind = "add_events_to_calendar" | "calendar_connection" | "community_agreement" | "complete_profile" | "connect_slack" | "custom_profile_field" | "default_profile_fields" | "download_mobile_app" | "onboarding_complete" | "onboarding_module" | "onboarding_welcome" | "slack_connection" | "slack_invite" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageSubmissionMethod = "mark_as_complete" | "submission" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CurriculumDrawerFooterContentFragment$data = {
  readonly content: {
    readonly systemTaskKind: ContentSystemTaskKind | null;
    readonly type: ContentType;
  };
  readonly id: string;
  readonly isLocked: boolean;
  readonly submissionMethod: ContentUsageSubmissionMethod | null;
  readonly viewerHasCompleted: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ContentUsageMarkAsCompleteButtonFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "CurriculumDrawerFooterContentFragment";
};
export type CurriculumDrawerFooterContentFragment$key = {
  readonly " $data"?: CurriculumDrawerFooterContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurriculumDrawerFooterContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurriculumDrawerFooterContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerHasCompleted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "systemTaskKind",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submissionMethod",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentUsageMarkAsCompleteButtonFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "d7c5f85ad8901ab3d9a9bacef94a152e";

export default node;
